<template>
    <div>

        <HeroDocker></HeroDocker>
        <GettingStarted></GettingStarted>

    </div>
</template>

<script>

    import HeroDocker from '../docker/HeroDocker.vue'
    import GettingStarted from '../docker/GettingStarted.vue'

    export default {
        name: 'Docker',
        components: {
          HeroDocker,
          GettingStarted
        },
        props: {
            msg: String
        },
        head: {
            title: {
                inner: 'About Skippr',
                separator: '-',
                complement: 'Data Integration and Preparation'
            },
            //omited
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
